import React from 'react'
import newsletter from "./images/newsletter.JPG";


export default function () {
  return (
    <div>
        <section id="news-letter" className="container-fluid row  mb-5 ">
  <div className="col-md-6">
    <img
      src={newsletter}
      className="img-fluid disable mt-5"
      alt=""
    />
  </div>
  <div className="col-md-6 mt-5 text-center">
    <h1>
      Get Every Monthly <br />
      <span className="text-success">Newsletter</span>
    </h1>
    <p className=" mt-sm-5">
      Select a category that best suites your interest. Use filters to
      coustomize your search and to find exactly what you want
    </p>
    <form action="" className="d-flex  mt-sm-5 justify-content-center">
      <input
        type="email"
        name="email"
        id="email"
        className=" w-50 border-0 p-md-2"
        required=""
        placeholder="Enter Email Address"
      />
      <button
        className=" btn btn-success border-0 text-light w-auto"
        id="newsletter-button"
      >
        Search <i className="fa fa-location-arrow" />
      </button>
    </form>
  </div>
</section>

    </div>
  )
}
